import Notify from 'quasar/src/plugins/Notify.js';;
var msg = {
  positive: function positive(message) {
    Notify.create({
      color: 'positive',
      position: 'top-right',
      message: message,
      icon: 'check_circle_outline',
      html: true,
      timeout: 10000,
      actions: [{
        icon: 'close',
        handler: Function,
        color: 'white'
      }]
    });
  },
  negative: function negative(message) {
    Notify.create({
      color: 'negative',
      position: 'top-right',
      message: message,
      icon: 'check_circle_outline',
      html: true,
      timeout: 10000,
      actions: [{
        icon: 'close',
        handler: Function,
        color: 'white'
      }]
    });
  },
  info: function info(message) {
    Notify.create({
      color: 'info',
      position: 'top-right',
      message: message,
      icon: 'check_circle_outline',
      html: true,
      timeout: 10000,
      actions: [{
        icon: 'close',
        handler: Function,
        color: 'white'
      }]
    });
  }
};
export default msg;